<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="pn">PART ONE</p>
<p class="pt">THE FIRST PROBES</p>
<p class="pdl">Thirty Days Later</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?f95f6f96